<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Features</h1>
                </div>
                
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="customSwitch1">
                <label class="custom-control-label" for="customSwitch1">Optimization<sup>BETA</sup></label>
                <small id="emailHelp" class="form-text text-muted">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lobortis scelerisque nisl id venenatis. Aliquam erat volutpat. Cras odio mi, venenatis id mi at, mattis rutrum dui. Integer ut lectus ante. Mauris congue mi ut quam iaculis consectetur. Proin auctor lorem sapien, id rutrum elit suscipit a.</small>
            </div>
            <br />

            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" disabled id="customSwitch2">
                <label class="custom-control-label" for="customSwitch2">Jira integration<sup>BETA</sup></label>
                <small id="emailHelp" class="form-text text-muted">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lobortis scelerisque nisl id venenatis. Aliquam erat volutpat. Cras odio mi, venenatis id mi at, mattis rutrum dui. Integer ut lectus ante. Mauris congue mi ut quam iaculis consectetur. Proin auctor lorem sapien, id rutrum elit suscipit a.</small>
            </div>
            <br />
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";

    @Component
    export default class ManageFeaturesPage extends mixins(PageBase) {
    }
</script>

<style scoped>
</style>